import { createContext, useContext, PropsWithChildren, RefObject } from 'react';
import { useMultiValueContainer } from './useMultiValueContainer';
import { ISelectOption } from '../../interfaces';

const MultiValueContainerContext = createContext<ReturnType<typeof useMultiValueContainer>>(null);

export const useMultiValueContainerContext = () => {
  const context = useContext(MultiValueContainerContext);
  if (!context) {
    throw new Error('useMultiValueContainerContext must be used within a MultiValueContainerContext');
  }
  return context;
};

interface IProps extends PropsWithChildren {
  value: ISelectOption[],
  containerRef: RefObject<HTMLDivElement>,
}

export const MultiValueContainerContextProvider = ({
  children,
  value,
  containerRef,
}: IProps) => (
  <MultiValueContainerContext.Provider
    value={ useMultiValueContainer({ value, containerRef }) }
  >
    { children }
  </MultiValueContainerContext.Provider>
);
